export const verificationType = {
    verificationType: [],
}
